export default "__VITE_ASSET__b3fff628__"